import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';

interface CopyIconProps {
  value: string | number;
  size?: number;
  label?: string;
  stopPropagation?: boolean;
  onCopy?: () => void;
}

/** The copy-to-clipboard icon IdBadge shows, usable beside any plain value such as a SKU. */
export const CopyIcon: React.FC<CopyIconProps> = ({
  value,
  size = 12,
  label = 'Copy',
  stopPropagation = false,
  onCopy,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = (e: React.MouseEvent) => {
    if (stopPropagation) {
      e.stopPropagation();
    }
    navigator.clipboard.writeText(String(value));
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
    onCopy?.();
  };

  if (copied) {
    return <Check size={size} style={{ color: '#28a745' }} aria-label="Copied!" />;
  }

  return (
    <Copy
      size={size}
      role="button"
      aria-label={label}
      style={{ cursor: 'pointer' }}
      // Copying must not take the cursor from whatever input holds it, such as a scan box.
      onMouseDown={(e) => e.preventDefault()}
      onClick={handleCopy}
    />
  );
};
